<template>
  <v-data-table
    :headers="columnKeys"
    :items="items"
    :options="pagination"
    :items-per-page="pagination.limit"
    :server-items-length="pagination.totalItems"
    @update:options="changePage"
    :loading="loading"
    loading-text="載入中...請稍候">

    <template v-slot:header.name="{ header }">
      {{ header.text }}
    </template>

    <template v-slot:progress>
      <v-progress-linear  :color="Theme.PINK" :height="3" indeterminate/>
    </template>


    <template v-slot:body="{ items }">
      <tbody>
      <tr v-for="(item, i) in items" :key="i">
        <td v-for="col in columnKeys" :key="col.key">
          <img v-if="col.isImage" :src="item[col.value]" style="height: 80px"/>
          <v-layout v-else-if="col.tags">
            <v-flex v-for="(subtype, i) of item[col.value]" :key="`subtype_${i}`">
              <v-chip>{{ subtype.name }}</v-chip>
            </v-flex>
          </v-layout>
          <v-layout column v-else-if="col.hasSpec">
            <div v-if="item.specList && item.specList.length > 0" >
              <v-flex v-for="(spec, i) of item.specList" :key="`${item.productId}_spec_${i}`">
                {{ spec.name }}: {{spec.price}}
              </v-flex>
            </div>
            <div v-else>
              <v-flex>{{ item.price }}</v-flex>
            </div>
          </v-layout>
          <v-btn :color="col.color ? col.color : 'red'" dark v-else-if="col.isEvent"
                 @click.stop="cellEvent(col.value, item)">{{col.text}}</v-btn>
          <v-btn flat text v-else-if="col.isTextEvent"
                 @click.stop="cellEvent(col.value, item)">{{item[col.value]}}</v-btn>
          <span v-else-if="col.options">
            <v-chip v-if="col.tag" :dark="isDarkTextColor(col, item)" :color="getSelectColor(col, item)"> {{ getSelectList(col, item) }}</v-chip>
            <span v-else>{{ getSelectList(col, item) }}</span>
          </span>
          <span v-else>{{ getValue(col, item[`${col.value}`])}}</span>
        </td>
      </tr>
      </tbody>
    </template>

    <template v-slot:no-data>
      <v-btn :color="Theme.GREEN" @click="reloadData">重新整理</v-btn>
    </template>
  </v-data-table>
</template>

<script>
  import common from "@/mixins/common";

  export default {
    name: 'TableView',
    mixins:[common],
    props: {
      columnKeys: Array,
      items: Array,
      loading: Boolean,
      pagination: Object,
    },
    methods:{
      getSelectList(col, option){
        // console.log(`getSelectList === ${option[col.value]}`);
        const find = col.options.find(item=>{
          const check = item.key === option[col.value] || `${item.key}` === `${option[col.value]}`;
          return check;
        });
        if (find){
          return find.value;
        }
        return '--'
      },
      isDarkTextColor(col, option){
        const find = col.options.find(item=>item.key === option[col.value]);
        if (find){
          return find.dark;
        }
        return true;
      },
      getSelectColor(col, option){
        // console.log(`getSelectList === ${option[col.value]}`);
        const find = col.options.find(item=>item.key === option[col.value]);
        if (find){
          return find.color;
        }
        return this.Theme.LIGHT_GRAY
      },
      changePage(page){
        console.log(`page ${JSON.stringify(page)}`);
        this.$emit('changePage', page);
      },
      changeSort(column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
      },
      cellEvent(key, item){
        this.$emit('cellEvent', {key:key, item: item });
      },
      getValue(col, text){
        if (col.emptyValue){
          return `${col.emptyValue === '' ? text : col.emptyValue}`;
        } else {
          return `${text}`;
        }
      },
      reloadData() { // 重整
        this.$emit('handleLoadData');
      },
    }
  };
</script>

<style scoped>

</style>
